import React, { Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import './App.css'
import { metaInfo } from './constants'
import { routesLinks } from './utils/RouteConstants'
import HomePage from './pages/HomePage'
import Careers from './pages/Careers/Careers'
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions'
import SchoolEnquiry from './pages/SchoolEnquiry'
import AIReadiness from './pages/AiReadiness'

const AboutUs = React.lazy(() => import('./pages/about-us1'))
const DemoPage = React.lazy(() => import('./pages/DemoPage/DemoPage'))
const DemoProfiles = React.lazy(() => import('./pages/DemoProfiles/DemoProfiles'))
const TeacherReportCard = React.lazy(() => import('./pages/TeachersDay2026/TeacherReportCard'))
const ParentsReportCard = React.lazy(() => import('./pages/TeachersDay2026/ParentsReportCard'))

const MetaDetails = ({ info }) => {
  const { title, meta_title, description, h1 } = info || {}
  return (
    <>
      <Helmet>
        {meta_title && <meta property="og:title" content={meta_title} />}
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
      </Helmet>
      {h1 && <h1 style={{ opacity: 0, height: 0, margin: 0, padding: 0, overflow: 'hidden' }}>{h1}</h1>}
    </>
  )
}

const RouteWithMeta = ({ info, children }) => (
  <>
    <MetaDetails info={info} />
    {children}
  </>
)

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route
          path={routesLinks.home}
          element={
            <RouteWithMeta info={metaInfo.home}>
              <HomePage />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.homev1}
          element={
            <RouteWithMeta info={metaInfo.home}>
              <HomePage />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.homev2}
          element={
            <RouteWithMeta info={metaInfo.home}>
              <HomePage />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.aboutus}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <RouteWithMeta info={metaInfo.about_us}>
                <AboutUs />
              </RouteWithMeta>
            </Suspense>
          }
        />
        <Route
          path={routesLinks.careers}
          element={
            <RouteWithMeta info={metaInfo.careers}>
              <Careers />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.privacypolicy}
          element={
            <RouteWithMeta info={metaInfo.privacy_policy}>
              <PrivacyPolicy />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.termsandconditions}
          element={
            <RouteWithMeta info={metaInfo.terms_and_conditions}>
              <TermsAndConditions />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.demoform}
          element={
            <RouteWithMeta info={metaInfo.demo}>
              <HomePage />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.aiReadiness}
          element={
            <RouteWithMeta info={metaInfo.test_ai_readiness}>
              <AIReadiness />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.schoolpartner}
          element={
            <RouteWithMeta info={metaInfo.school_partner}>
              <SchoolEnquiry />
            </RouteWithMeta>
          }
        />
        <Route
          path={routesLinks.demorun}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <RouteWithMeta info={metaInfo.demorun}>
                <DemoPage />
              </RouteWithMeta>
            </Suspense>
          }
        />
        <Route
          path={routesLinks.demoprofiles}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <RouteWithMeta info={metaInfo.demoprofiles}>
                <DemoProfiles />
              </RouteWithMeta>
            </Suspense>
          }
        />
        <Route
          path={routesLinks.teachersDay2026}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <RouteWithMeta info={metaInfo.teachers_day_2026}>
                <TeacherReportCard />
              </RouteWithMeta>
            </Suspense>
          }
        />
        <Route
          path={routesLinks.teachersDay2026Parents}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <RouteWithMeta info={metaInfo.teachers_day_2026_parents}>
                <ParentsReportCard />
              </RouteWithMeta>
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to={routesLinks.home} replace />} />
      </Routes>
    </HelmetProvider>
  )
}

export default App
